import React from "react";
import { connect } from "react-redux";

import Slider from "../../components/Slider";
import Graph from "../../components/graphs/ZoomedGraph";
import GraphOptions from "./GraphOptions";
import {
  Main,
  GraphDetailContainer,
  SliderContainer,
  RightArrowIconSt,
  LeftArrowIconSt,
  ZoomedMainArea as MainArea,
  ZoomedGraphContainer as GraphContainer
} from "../../components/StyledComponents";

const SectorZoomed = props => {
  const { theme, data } = props;
  return (
    <>
      <GraphOptions />
      <Main>
        <GraphDetailContainer>
          <MainArea>
            <GraphContainer>
              <LeftArrowIconSt />
              <Graph
                data={data}
                color="#E26A71"
                gradient={
                  theme === "dark"
                    ? ["#041A2F", "#E26A71"]
                    : ["#E8DBDB", "#E26A71"]
                }
              />
              <RightArrowIconSt />
            </GraphContainer>

            <SliderContainer>
              <Slider theme={theme} />
            </SliderContainer>
          </MainArea>
        </GraphDetailContainer>
      </Main>
    </>
  );
};

const mapStateToProps = state => ({
  theme: state.themes.theme,
  data: state.sectorZoomed.data
});

export default connect(
  mapStateToProps,
  null
)(SectorZoomed);
